// extracted by mini-css-extract-plugin
module.exports = {"benefits":"EuBenefits_benefits__3HFEu"};